<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-btn v-if="inEditMode && user.id != 0" class="ml-2 mr-2" color="primary" @click="saveClick(false)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                </v-btn>
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(true)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndExit') }}
                </v-btn>
                <v-btn v-if="!inEditMode && user.id != 0" class="ml-2 mr-2" color="primary" @click="newPasswordClick">
                    <v-icon small>fa-lock</v-icon>&nbsp;{{ $t('buttons.generateNewPassword') }}
                </v-btn>
                <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
                <v-btn class="mr-2" @click="backClick">
                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" xl="3" lg="4" md="6">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="12">
                                <InputField
                                    :maxlength="50"
                                    :readonly="!inEditMode"
                                    v-model="user.first_name"
                                    :errorBorder="!userValidation.first_name"
                                    :label="'* ' + $t('fields.firstName')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :maxlength="50"
                                    :readonly="!inEditMode"
                                    v-model="user.last_name"
                                    :errorBorder="!userValidation.last_name"
                                    :label="'* ' + $t('fields.lastName')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :maxlength="50"
                                    :readonly="!inEditMode"
                                    v-model="user.email"
                                    :errorBorder="!userValidation.email"
                                    :label="'* ' + $t('fields.email')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :maxlength="20"
                                    :readonly="!inEditMode"
                                    v-model="user.contact_number"
                                    :errorBorder="!userValidation.contact_number"
                                    :label="$t('fields.contactNumber')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <Dropdown
                                    :readonly="!inEditMode"
                                    v-model="user.user_role_id"
                                    :ajax="true"
                                    :data="'user-roles'"
                                    :errorBorder="!userValidation.user_role_id"
                                    :label="'* ' + $t('fields.role')"
                                ></Dropdown>
                            </v-col>
                            <v-col v-if="user.id == 0" cols="12">
                                <InputField
                                    :maxlength="20"
                                    :readonly="!inEditMode"
                                    v-model="user.password"
                                    :errorBorder="!userValidation.password"
                                    :label="'* ' + $t('fields.password')"
                                    :type="'password'"
                                ></InputField>
                            </v-col>
                            <v-col v-if="user.id == 0" cols="12">
                                <InputField
                                    :maxlength="20"
                                    :readonly="!inEditMode"
                                    v-model="repeatPassword"
                                    :errorBorder="!repeatPasswordValidation"
                                    :label="'* ' + $t('fields.repeatPassword')"
                                    :type="'password'"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <CheckBox
                                    :readonly="!inEditMode"
                                    v-model="user.active"
                                    :label="$t('fields.active')"
                                ></CheckBox>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import InputField from './trinkets/InputField';
import CheckBox from './trinkets/CheckBox';
import Dropdown from './trinkets/Dropdown';
import User from '../models/User';

export default {
    name: 'UserAccount',
    components: {CheckBox, InputField, Dropdown},
    data: function () {
        return {
            user: new User({id: this.$route.params.id}),
            userValidation: new User({}, true),
            initialLoad: false,
            inEditMode: false,
            lockKey: 'user-account',
            lockTimer: null,
            repeatPassword: '',
            repeatPasswordValidation: true,
        };
    },
    methods: {
        editClick() {
            let vm = this;
            this.$setLock(this, this.lockKey + '|' + this.user.id, (data) => {
                if (data.success) {
                    vm.inEditMode = true;
                    vm.lockTimer = setInterval(() => {
                        vm.$setLock(vm, vm.lockKey + '|' + vm.user.id);
                    }, 10000);
                } else {
                    vm.$alert(
                        this.$t('alerts.recordLocked')
                            .split('%name%')
                            .join(data.locked_by.first_name + ' ' + data.locked_by.last_name),
                    );
                }
            });
        },
        newPasswordClick() {
            let vm = this;
            this.$verify(this.$t('alerts.generatePasswordQuestion'), (result) => {
                if (result) {
                    vm.$APICall('post', 'password-recovery', {email: vm.user.email}, (data, success) => {
                        if (success) {
                            vm.$alert(vm.$t('alerts.passwordResetSuccess'));
                        } else {
                            vm.$alert(vm.$t('alerts.passwordResetFail'));
                        }
                    });
                }
            });
        },
        backClick() {
            if (window.history.state == null) {
                this.$router.push('/user-accounts');
            } else {
                this.$router.go(-1);
            }
        },
        saveClick(goBack) {
            let success = true;

            if (this.user.first_name == '') {
                success = false;
                this.userValidation.first_name = false;
            } else {
                this.userValidation.first_name = true;
            }

            if (this.user.last_name == '') {
                success = false;
                this.userValidation.last_name = false;
            } else {
                this.userValidation.last_name = true;
            }

            if (this.user.email == '') {
                success = false;
                this.userValidation.email = false;
            } else {
                if (!this.$checkEmail(this.user.email)) {
                    success = false;
                    this.userValidation.email = false;
                } else {
                    this.userValidation.email = true;
                }
            }

            if (this.user.id == 0) {
                if (this.user.password.trim() == '') {
                    success = false;
                    this.userValidation.password = false;
                } else {
                    let passwordValidation = '';

                    if (this.user.password.length < 8) {
                        success = false;
                        this.userValidation.password = false;
                        passwordValidation += this.$t('alerts.passwordLength') + '<br />';
                    }

                    let letters = 0;
                    let digits = 0;
                    let others = 0;
                    for (let i = 0; i < this.user.password.length; i++) {
                        let character = this.user.password[i];
                        let letter = character.toLowerCase() !== character.toUpperCase();
                        let digit = character >= '0' && character <= 9;
                        if (letter) letters++;
                        if (digit) digits++;
                        if (!letter && !digit) others++;
                    }
                    if (letters === 0) passwordValidation += this.$t('alerts.passwordLetters') + '<br />';
                    if (digits === 0) passwordValidation += this.$t('alerts.passwordDigits') + '<br />';
                    if (others === 0) passwordValidation += this.$t('alerts.passwordOthers') + '<br />';

                    if (passwordValidation !== '') {
                        this.$alert(passwordValidation);
                    } else {
                        this.userValidation.password = true;
                    }
                }

                if (this.repeatPassword.trim() != this.user.password.trim()) {
                    success = false;
                    this.repeatPasswordValidation = false;
                } else {
                    this.repeatPasswordValidation = true;
                }
            }

            if (this.user.user_role_id == null) {
                success = false;
                this.userValidation.user_role_id = false;
            } else {
                this.userValidation.user_role_id = true;
            }

            if (success) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.user.id != 0) {
                    action = 'put';
                    addition = '/' + vm.user.id;
                }
                this.$APICall(action, 'users' + addition, this.user, (data, success) => {
                    if (success) {
                        vm.inEditMode = false;
                        if (vm.user.id == 0) {
                            vm.$notify(vm.$t('alerts.basicAdd'));
                        } else {
                            vm.$notify(vm.$t('alerts.basicUpdate'));
                        }
                        if (this.lockTimer !== null) clearInterval(this.lockTimer);
                        vm.$removeLock(vm, vm.lockKey + '|' + vm.user.id);
                        vm.$triggerReload();
                        // If the admin edited their own account, re-sync the cached
                        // user immediately so a role change reflects without a reload.
                        if (vm.user.id === vm.$myStore.state.user.id) {
                            vm.$APICall(
                                'get',
                                'session',
                                {},
                                (sessionData, sessionSuccess) => {
                                    if (sessionSuccess && sessionData) {
                                        vm.$myStore.commit('setUser', sessionData);
                                    }
                                },
                                false,
                            );
                        }
                        if (goBack) {
                            vm.backClick();
                        }
                    } else {
                        vm.$alert(vm.$t('alerts.userExists'));
                    }
                });
            }
        },
    },

    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
                    vm.$removeLock(vm, vm.lockKey + '|' + vm.user.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            next(true);
        }
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let vm = this;
        if (this.user.id != 0) {
            this.$APICall('get', 'users/' + this.user.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.user = usableData;
                    vm.$myStore.commit('setBreadcrumbs', [
                        {
                            text: vm.$t('modules.userAccounts'),
                            href: '/#/user-accounts',
                            disabled: false,
                        },
                        {
                            text: vm.user.email,
                            href: '/#/user-accounts/' + vm.user.id,
                            disabled: true,
                        },
                    ]);
                    vm.$nextTick(() => {
                        vm.initialLoad = true;
                    });
                }
            });
        } else {
            this.$myStore.commit('setBreadcrumbs', [
                {
                    text: this.$t('modules.userAccounts'),
                    href: '/#/user-accounts',
                    disabled: false,
                },
                {
                    text: this.$t('modules.newUserAccount'),
                    href: '/#/user-accounts/0',
                    disabled: true,
                },
            ]);
            this.inEditMode = true;
            this.initialLoad = true;
        }
    },
};
</script>

<style scoped></style>
